// extracted by mini-css-extract-plugin
module.exports = {"TechInfo":"TechInfo_TechInfo__1qy5P","Card":"TechInfo_Card__2u1Qk","CardContent":"TechInfo_CardContent__3Fg4F","Cell":"TechInfo_Cell__1ze8d"};